import React, { Component } from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FormattedMessage } from "react-intl";
import LocaleLink from '../../Routes/LocaleLink'


class HomepageSpirit extends Component
{
    parallax = React.createRef()

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.parallax.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(40 * delta - 210) + 'px'
    }

    render() {
        return (
            <section className="section-spirit">
                <div className="section-spirit-after" ref={this.parallax}/>
                <div className="container">
                    <div className="spirit-head">
                        <h2>
                            <FormattedMessage
                                id="portfolio.homepage.spirit.title"
                                defaultMessage="L’ESPRIT URBAN LINKER"
                            />
                        </h2>
                    </div>
                    <div className="spirit-block">
                        <div className="spirit-text">
                            <LocaleLink to="/team">
                                <h4>
                                    <FormattedMessage
                                        id="portfolio.homepage.spirit.dream_team"
                                        defaultMessage="La dream team"
                                    />
                                </h4>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.homepage.spirit.experts"
                                        defaultMessage="Plus de 60 experts qui parlent le même langage que vous !"
                                    />
                                </p>
                                <FontAwesomeIcon icon={faArrowRight} className="icon-arrow-right"/>
                            </LocaleLink>
                        </div>
                        <div className="spirit-text">
                            <LocaleLink to="/recruter-talent">
                                <h4>
                                    <FormattedMessage
                                        id="portfolio.homepage.spirit.serious"
                                        defaultMessage="Serious gets fun"
                                    />
                                </h4>
                                <FontAwesomeIcon icon={faArrowLeft} className="icon-arrow-right d-none d-lg-inline-block"/>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.homepage.spirit.dna"
                                        defaultMessage="Découvrez notre ADN et nos processus de recrutement"
                                    />
                                </p>
                                <FontAwesomeIcon icon={faArrowRight} className="icon-arrow-right d-lg-none"/>
                            </LocaleLink>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default HomepageSpirit;
